import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import axios from 'axios';
import store from './store';
import ErrorBoundary from './components/shared/ErrorBoundary';
import PrivateRoute from './components/shared/PrivateRoute';
import './i18n'; // i18n initialization

import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import './styles/global.css';

const HomePage = React.lazy(() => import('./pages/HomePage'));
const ProductsPage = React.lazy(() => import('./pages/ProductsPage'));
const ProductDetailPage = React.lazy(() => import('./pages/ProductDetailPage'));
const CartPage = React.lazy(() => import('./pages/CartPage'));
const CheckoutPage = React.lazy(() => import('./pages/CheckoutPage'));
const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const RegisterPage = React.lazy(() => import('./pages/RegisterPage'));
const DashboardPage = React.lazy(() => import('./pages/DashboardPage'));
const AboutPage = React.lazy(() => import('./pages/AboutPage'));
const ContactPage = React.lazy(() => import('./pages/ContactPage'));
const NotFoundPage = React.lazy(() => import('./pages/NotFoundPage'));
const AdminPage = React.lazy(() => import('./pages/AdminPage'));

const App = () => {
  useEffect(() => {
    // Get CSRF token on app load
    const API_URL = process.env.REACT_APP_API_URL || '/api/v1';
    axios.get(`${API_URL}/health`, { withCredentials: true }).catch(() => {});
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <ErrorBoundary>
          <div className="app">
            <Header />
            <main className="app__main">
              <React.Suspense fallback={<div className="app__loading">Yuklanmoqda...</div>}>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/products" element={<ProductsPage />} />
                  <Route path="/products/:slug" element={<ProductDetailPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="*" element={<NotFoundPage />} />
                  <Route path="/cart" element={<PrivateRoute><CartPage /></PrivateRoute>} />
                  <Route path="/checkout" element={<PrivateRoute><CheckoutPage /></PrivateRoute>} />
                  <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
                  <Route path="/admin" element={<PrivateRoute roles={['admin', 'manager']}><AdminPage /></PrivateRoute>} />
                </Routes>
              </React.Suspense>
            </main>
            <Footer />
            <Toaster position="top-right" />
          </div>
        </ErrorBoundary>
      </Router>
    </Provider>
  );
};

export default App;
